import React from "react";
import "./SlackBlock.scss";
import {Text} from "../../../../modules";
import {useTranslation} from "react-i18next";
import {Button} from "../../../../modules/Button";
import {useSelector} from "react-redux";
import {useCalendarActions} from "../../hooks";

const SlackBlock = () => {
    const {t} = useTranslation();
    const {GetAuthorizationUrlSlack, LogOutSlack} = useCalendarActions();
    const userProfile = useSelector(state => state.profile.userProfile);

    return (
        <div className="slack-block">
            <Text font="medium" size="f18" className="slack-block--title">
                Slack
            </Text>
            {userProfile?.slack_connected ? (
                <>
                    <div className="slack-block__info">
                        <div className="slack-block__info--text">
                            <Text size="f14" font="book" color="#9898A6" as="p">
                                {" "}
                                {t("slack_connected_sub_title")}{" "}
                            </Text>
                        </div>
                        <Button
                            text={t("calendar_settings_disconnect")}
                            onClick={LogOutSlack}
                            variant="secondary"
                            color="red"
                            size="s"
                        />
                    </div>
                </>
            ) : (
                <>
                    <div className="slack-block__top">
                        <Text font="liteMedium" size="f16" color="#9898A6">
                            {t('slack_connected_desc')}
                        </Text>
                    </div>
                    <div className="slack-block__bottom">
                        <Text font="liteMedium" size="f16" color="#9898A6">
                            {t('slack_connected_desc_btn')}
                        </Text>
                        <Button
                            text={t("connect")}
                            size="s"
                            onClick={GetAuthorizationUrlSlack}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default SlackBlock;
